import { createSelector } from '@ngrx/store';

import { getPaymentState } from '../getPaymentState';

export const isBrowserBasedPaymentMethod = createSelector(getPaymentState, (paymentState) => Boolean(paymentState.paymentMethod?.vendorService));
